import { useSelector } from 'react-redux';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import LastComponent from './common/lastComponent';

export default function ExtraSection({ componentProps }) {
  const { theme } = useSelector((state) => state.ui);
  const { componentName, componentData, componentFullName, isLastComponent } =
    componentProps;
  const component = componentData[componentFullName];
  const componentQuantity = component.quantity ? Number(component.quantity) : 1;

  return (
    <div className="flex mt-[30px] xs:mt-[40px] items-start relative">
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hidden xs:inline"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.brandColour || DEFAULT_SECONDARY_COLOUR}
        />
        <path
          d="M29.8019 24.1451H26.1391V20.4823H24.1451V24.1451H20.4823V26.1392H24.1451V29.802H26.1391V26.1392H29.8019V24.1451ZM32.2132 18.0711C28.3029 14.1608 21.9813 14.1608 18.071 18.0711C14.1607 21.9814 14.1607 28.3029 18.071 32.2132C21.9813 36.1235 28.3029 36.1235 32.2132 32.2132C36.1235 28.3029 36.1235 21.9814 32.2132 18.0711ZM19.4852 30.799C16.3669 27.6806 16.3669 22.6036 19.4852 19.4853C22.6036 16.3669 27.6806 16.3669 30.7989 19.4853C33.9173 22.6036 33.9173 27.6806 30.7989 30.799C27.6806 33.9173 22.6036 33.9173 19.4852 30.799Z"
          fill="white"
        />
      </svg>

      <div className="xs:ml-[16px] mt-2">
        <div className="text-[22px] leading-[29.05px] font-medium flex xs:block items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative z-10 inline xs:hidden"
          >
            <circle
              cx="25"
              cy="25"
              r="25"
              fill={theme.primaryColour || DEFAULT_SECONDARY_COLOUR}
            />
            <path
              d="M29.8019 24.1451H26.1391V20.4823H24.1451V24.1451H20.4823V26.1392H24.1451V29.802H26.1391V26.1392H29.8019V24.1451ZM32.2132 18.0711C28.3029 14.1608 21.9813 14.1608 18.071 18.0711C14.1607 21.9814 14.1607 28.3029 18.071 32.2132C21.9813 36.1235 28.3029 36.1235 32.2132 32.2132C36.1235 28.3029 36.1235 21.9814 32.2132 18.0711ZM19.4852 30.799C16.3669 27.6806 16.3669 22.6036 19.4852 19.4853C22.6036 16.3669 27.6806 16.3669 30.7989 19.4853C33.9173 22.6036 33.9173 27.6806 30.7989 30.799C27.6806 33.9173 22.6036 33.9173 19.4852 30.799Z"
              fill="white"
            />
          </svg>
          <span className="ml-2.5 xs:ml-0">{componentName}</span>
        </div>
        <div className="max-w-10/12 text-[16px] leading-[31.2px] tracking-[0.25px] font-normal mt-[22px]">
          {component.name && (
            <div>
              <strong>{component.name}</strong> x{' '}
              {componentQuantity < 1 ? 1 : componentQuantity}
              <br />
            </div>
          )}
        </div>
      </div>

      {isLastComponent && <LastComponent />}
    </div>
  );
}
